import {Component, Inject, OnInit} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiService} from './shared/services/api.service';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {InternalService} from './shared/services/internal.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {Title} from '@angular/platform-browser';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // title = 'Elimedi Admin panel';

  constructor(private title: Title,
              private apiService: ApiService,
              @Inject(SESSION_STORAGE) private session: WebStorageService,
              public internalService: InternalService,
              private router: Router,
              private cookieService: CookieService,
              public translete: TranslateService,
              public oidcSecurityService: OidcSecurityService, public http: HttpClient,) {
  }


  ngOnInit() {

    // if(this.apiService.currentDirection == 'rtl'){
    //   this.title.setTitle('خیریه');
    // }else{
    //   this.title.setTitle('Charity');
    // }
    // this.apiService.RegisterConfirm().subscribe((response: any) => {
    //   console.log('RegisterConfirm',response);
    //   this.cookieService.set('currentUserRoles', JSON.stringify(response.res.role));
    //   this.cookieService.set('fullName', response.res.name);
    //   console.log(this.oidcSecurityService.getToken());
    // })
    if (this.session.get('dir') === 'rtl' || this.session.get('dir') == null) {
      this.apiService.currentDirection = this.session.get('dir');
      this.changeLang('fa-ir');
      this.title.setTitle('خیریه');
    } else {
      this.apiService.currentDirection = this.session.get('dir');
      this.changeLang('en-us');
      this.title.setTitle('Charity');
    }



  }



  changeLang(language) {
    this.internalService.changeLang(language, 0);
  }

}
